import { DocFlowPhaseItemStatus } from '../../../DocFlow'

export const PROFILE_HEADER_DOCUMENT_STAPLING_TITLE = 'Invoice_2024'

export const PROFILE_HEADER_DOCUMENT_STAPLING_ACTIVE_PHASE =
  DocFlowPhaseItemStatus.Combining

export const PROFILE_HEADER_DOCUMENT_STAPLING_DOC_FLOW_MOCK = {
  archived: false,
  documents_count: 3,
  final_document_template_name: 'Invoice {{current_date}}',
  name: PROFILE_HEADER_DOCUMENT_STAPLING_TITLE,
  permissions: {
    can_edit_final_document_template_name: true,
    can_move_to_next_phase: true,
  },
  phase: DocFlowPhaseItemStatus.Combining,
  status: 1,
  uk_epost_credits: 1500,
}
